export default "__VITE_ASSET__DIJI0xY1__"